export default __webpack_public_path__ + "b4dd4707454b2f716cf4e0f692715541.png";